var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "20px",
    height: "20px",
    viewBox: "0 0 10.92 13.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1732130203744"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    className: "fil0",
    d: "M6.13 10.8l-3.26 0 0 -3.53 3.37 0c0.99,0 1.78,0.6 1.78,1.75 0,0.65 -0.1,1 -0.55,1.39 -0.27,0.23 -0.86,0.4 -1.35,0.4zm-6.13 2.25l6.55 0c1.61,0 3.38,-0.7 4.07,-2.25 0.46,-1.02 0.37,-2.43 -0.18,-3.42 -0.77,-1.38 -2.61,-2.08 -4.28,-2.08l-3.3 0 0 -5.27 -2.87 0 0 13.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    className: "fil0",
    d: "M3.26 2.27l2.44 0c0.85,0 1.78,0.34 1.78,1.28 0,0.37 0.03,0.66 -0.14,0.98 -0.11,0.21 -0.22,0.26 -0.32,0.41 0.51,0.04 1.69,0.43 2.13,0.66 0.5,-0.34 0.91,-0.87 1.07,-1.57 0.32,-1.38 -0.17,-3.02 -1.51,-3.57 -0.33,-0.14 -0.64,-0.25 -1,-0.32 -1.13,-0.21 -3.21,-0.13 -4.45,-0.13l0 2.25z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbps);
export default __webpack_public_path__ + "static/media/BBPS.acfdb9dc518012187a36500fc9e7ecfb.svg";
export { ForwardRef as ReactComponent };